export class FocusObserver {

	private _io?: IntersectionObserver;
	private _options = {
		root: null,
		margin: 0,
		threshold: 0
	};
	private _onFocusIn: (() => void)[] = [];
	private _onFocusOut: (() => void)[] = [];
	private _active = false;
	private _focused = false;

	constructor(private _DOM: HTMLElement, options = {}) {
		Object.assign(this._options, options);
		this._io = new IntersectionObserver((entries) => {
			// Only one element should be bound. Check last entry only.
			let entry = entries[entries.length-1];
			// Visible
			if (entry.intersectionRatio > 0) {
				this._focused = true;
				for (let func of this._onFocusIn) {
					func.call(this._DOM);
				}
			}
			// Hidden
			else {
				this._focused = false;
				for (let func of this._onFocusOut) {
					func.call(this._DOM);
				}
			}
		}, {
			root: this._options.root,
			rootMargin: this._options.margin + 'px',
			threshold: this._options.threshold
		});
	}


	focus() {
		return new Promise<boolean>((resolve) => {
			if (this._focused) {
				resolve(true);
			} else {
				this.oneFocus(() => {
					resolve(true);
				});
			}
		});
	}
	focusOut() {
		return new Promise<boolean>((resolve) => {
			if (!this._focused) {
				resolve(true);
			} else {
				this.oneFocusOut(() => {
					resolve(true);
				});
			}
		});
	}

	onFocus(func: () => void) {
		this._onFocusIn.push(func);
	}
	oneFocus(func: () => void) {
		let unbind = () => {
			this.offFocus(func);
			this.offFocus(unbind);
		};
		this._onFocusIn.push(func);
		this._onFocusIn.push(unbind);
	}
	offFocus(func: () => void) {
		let index = this._onFocusIn.indexOf(func);
		while (index >= 0) {
			this._onFocusIn.splice(index, 1);
			index = this._onFocusIn.indexOf(func);
		}
	}

	onFocusOut(func: () => void) {
		this._onFocusOut.push(func);
	}
	oneFocusOut(func: () => void) {
		let unbind = () => {
			this.offFocusOut(func);
			this.offFocusOut(unbind);
		};
		this._onFocusOut.push(func);
		this._onFocusOut.push(unbind);
	}
	offFocusOut(func: () => void) {
		let index = this._onFocusOut.indexOf(func);
		while (index >= 0) {
			this._onFocusOut.splice(index, 1);
			index = this._onFocusOut.indexOf(func);
		}
	}

	activate() {
		if (!this._active) {
			this._active = true;
			this._io.observe(this._DOM);
		}
		return this;
	}

	deactivate() {
		if (this._active) {
			this._active = false;
			this._io.unobserve(this._DOM);
		}
		return this;
	}
}
